import React, { useState } from "react";
import styled from "styled-components";

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 600px;
  margin: auto;
  overflow: hidden;
  background-color: #293142;
  border-top: 1px solid #596378;
  color: white;
`;

const CarouselInner = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: ${({ currentIndex }) => `translateX(-${currentIndex * 100}%)`};
`;

const CarouselItem = styled.div`
  min-width: 100%;
  box-sizing: border-box;
  display: flex;
  padding: 10px;
  gap: 10px;
`;

const CarouselImageWrapper = styled.div`
  width: 41px;
  height: 41px;
  overflow: hidden;
  position: relative;
`;

const CarouselImage = styled.img`
  width: 100%;
  height: auto;
`;

const CarouselTitle = styled.div`
  font-size: 13px !important;
  margin-top: 6px;
  font-weight: 700;
`;

const Button = styled.button`
  width: 20px;
  height: 5px;
  border-radius: 30px;
  background: ${({ active }) => (active ? "white" : "grey")};
  border: none;
  outline: none;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  position: absolute;
  bottom: 13px;
  left: 60px;
`;

const LeftText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 10px !important;
  font-weight: 700;
`;

const Carousel = ({ data = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <CarouselWrapper>
      <CarouselInner currentIndex={currentIndex}>
        {data.map((item, index) => (
          <CarouselItem key={index}>
            <CarouselImageWrapper>
              <CarouselImage src={item?.image} />
              <LeftText>{item?.leftText}</LeftText>
            </CarouselImageWrapper>
            <CarouselTitle>{item?.title}</CarouselTitle>
          </CarouselItem>
        ))}
      </CarouselInner>
      {data.length > 1 && (
        <ButtonWrapper>
          {data.map((_, index) => (
            <Button
              active={currentIndex === index}
              key={index}
              onClick={() => goToSlide(index)}
            />
          ))}
        </ButtonWrapper>
      )}
    </CarouselWrapper>
  );
};

export default Carousel;
